window.addEventListener("OpusOpenCartState", (event) => {
  const imageText = document.querySelector("#opus-image-text-ct-container");
  if (imageText) {
    imageText.remove();
  }

  const checkoutBtn = document.querySelector(".cd-checkout-section-button");
  checkoutBtn.insertAdjacentHTML(
    "afterend",
    `<div id="opus-image-text-ct-container" style="width: 100%; display: flex; justify-content: center; align-items: center; margin-top: 10px;">
      <img style="object-fit: contain;" src="https://cdn.shopify.com/s/files/1/0616/0773/9443/files/drawer_cart_customer_reviews_stars.png?v=1742206020" alt="" />
      <span>700,000+ HAPPY CUSTOMERS</span>
    </div>`
  );
});

window.addEventListener("OpusCartChange", (event) => {
  const data = event.detail;
  const sectionCustom = document.querySelector("#opus-price-ct-container");
  if (sectionCustom) {
    sectionCustom.remove();
  }
  const stringOpus = window.localStorage.getItem("opusCartV2");
  const ObjectPrice = JSON.parse(stringOpus);
  let discountCompare = 0;
  const listItemDetail = data.items;
  for (const item of listItemDetail) {
    const listKeys = Object.keys(ObjectPrice);
    if (listKeys.includes(`${item.id}`)) {
      const ogPrice = ObjectPrice[`${item.id}`]?.compareAtPrice || 0;
      if (ogPrice) {
        const flPrice = item.final_price;
        const lastPrice = ogPrice - flPrice;
        discountCompare = discountCompare + lastPrice * item.quantity;
      }
    }
  }

  const checkoutBtn = document.querySelector("#opus-checkout-btn");
  checkoutBtn.insertAdjacentHTML(
    "beforebegin",
    `<div id="opus-price-ct-container" style="width: 100%; display: flex; flex-direction: column; font-size: 1.3em; padding-top: 10px; ">
                ${
                  discountCompare
                    ? `
                <div style="display: flex; justify-content: space-between; align-items: center; border-radius: 4px;">
                    <span style="color: red; font-weight: bold; cursor: pointer;">
                    Savings
                    </span>
                    <span style="color: red; font-weight: bold; cursor: pointer;"> -${window.OpusConvertMoney(
                      discountCompare
                    )}</span>
                </div>
                `
                    : ""
                }
                
                <div style="width: 100%; display: flex; padding-top: 1px; justify-content: space-between; font-weight: bold; gap: 10px; margin: auto;">
                    <span style="flex-shrink: 0; align-items: center;">
                    <strong>Estimated Total</strong>
                    </span>
                    
                    <div style="display: flex; gap: 5px; justify-content: center; align-items: center;">
                    <span>${data.money}</span>
                    </div>
                </div>
            </div>`
  );
});
